<template>
  <div class="reupload-paper-online-list">
    <div class="title">在线补充资料</div>
    <div class="material-list">
      <div class="material-item" v-for="item in paperOnline" :key="item.id">
        <upload-item
          :pdf="true"
          :file-name="item.filename"
          :img-url="item.url"
          :upload="item"
          :forbid="true"
          @reviewImage="reviewImage">
        </upload-item>
      </div>
    </div>
  </div>
</template>

<script>

import uploadItem from '../../upload/upload-item';

export default {
  components: {
    uploadItem,
  },
  props: {
    paperOnline: {
      type: Array,
      default: [],
    },
  },
  methods: {
    reviewImage(url) {
      this.$emit('reviewImage', url);
    },
  },
};
</script>

<style lang="less">
.reupload-paper-online-list {
  padding: 20px 10px 0 30px;
  background-color: #ffffff;
  margin-bottom: 10px;
  .title{
    font-size: 16px;
    color: #333333;
    padding-bottom: 20px;
  }
  .material-list{
    display: flex;
    flex-wrap: wrap;
    .material-item{
      margin: 0 40px 30px 0;
      width: 200px;
      height: 132px;
      background-color: #e6e6e6;
      border-radius: 4px;
      border: solid 1px #f0f0f0;
      .upload-item{
        width: 100%;
        height: 100%;
      }
    }
  }
}
.el-message-box__wrapper{
  overflow: auto;
  .image-box{
    width: 50%;
    position: absolute;
    top: 10%;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 50px;
    .el-message-box__content{
      .el-message-box__message{
        .preview-img{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/reupload/reupload-paper-online/reupload-paper-online-list.vue